import { EventRow } from './logger.event-row';
import { loggerConstants } from 'app/logger/logger.constants';

export class DataFlowColumnsEvent extends EventRow {
    constructor(
        entityName: string,
        entityType: string,
        properties: { [key: string]: string },
        owner: string
    ) {
        super(
            loggerConstants.Event_DataFlowAuthoringUIAction, properties
        );
        this.addToProperties('operation', loggerConstants.Operation_ColumnsStatistic);
        this.addToProperties('resourceName', entityName);
        this.addToProperties('resourceType', entityType);
        this.addToProperties('owner', owner);
    }
}
